// extracted by mini-css-extract-plugin
export var downArrow = "_au-0";
export var label = "_au-1";
export var treatmentCard = "_au-3";
export var upArrow = "_au-2";